export default __webpack_public_path__ + "static/media/correct-answer.f706d8a6.svg";